module.exports = __webpack_public_path__ + "static/media/icon-car.37fa01fd.svg";